import { render, staticRenderFns } from "./iocIframe.vue?vue&type=template&id=1cf4912c&scoped=true"
import script from "./iocIframe.vue?vue&type=script&lang=js"
export * from "./iocIframe.vue?vue&type=script&lang=js"
import style0 from "./iocIframe.vue?vue&type=style&index=0&id=1cf4912c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf4912c",
  null
  
)

export default component.exports